module.exports = __webpack_public_path__ + "img/rt_vt.9fda8827.jpg";